export default __webpack_public_path__ + "static/media/fsk-13-fix01.265c8435.jpg";